export const chartsVersion = '45';

export default {
    chartsVersion
};
